import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)`
  align-self: center;
`;
